<button
	*ngIf="isDev"
	class="items-center justify-center flex fixed left-m bottom-m z-[1337] w-2xl h-2xl p-xl drop-shadow-md transition-all hover:scale-110 rounded-full text-white"
	[class]="{
		'bg-interaction-active': !mockMode,
		'bg-functional-warning-70': mockMode,
		'hover:bg-functional-warning-70': !mockMode,
		'hover:bg-interaction-active': mockMode,
	}"
	variant="primary"
	(click)="toggleMockMode()"
	(mouseenter)="hovered.set(true)"
	(mouseleave)="hovered.set(false)"
>
	{{ mockModeButtonLabel() }}
</button>
